// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Overlay ===== */
.ReusablePopup_popup-overlay__ecyoL {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ReusablePopup_popup-fade-in__-bcDJ 0.18s ease-out;
  padding: 16px;
}

/* ===== Container ===== */
.ReusablePopup_popup-container__-g4G5 {
  background: #ffffff;
  border-radius: 14px;
  box-shadow:
    0 20px 40px rgba(15, 23, 42, 0.18),
    0 4px 12px rgba(15, 23, 42, 0.08);
  width: 100%;
  max-width: 440px;
  padding: 28px 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: ReusablePopup_popup-scale-in__tEZIu 0.2s cubic-bezier(0.22, 1, 0.36, 1);
  position: relative;
}

/* ===== Icon ===== */
.ReusablePopup_popup-icon__luDfL {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(79, 70, 229, 0.1);
  margin-bottom: 14px;
  font-size: 24px;
  line-height: 1;
}

/* ===== Heading ===== */
.ReusablePopup_popup-heading__qgXhS {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.35;
}

/* ===== Subtext ===== */
.ReusablePopup_popup-subtext__IZLeZ {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

/* ===== Paragraph ===== */
.ReusablePopup_popup-paragraph__INKTF {
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
  margin: 0 0 20px 0;
  line-height: 1.55;
}

/* ===== Actions ===== */
.ReusablePopup_popup-actions__P4YXK {
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-top: 8px;
}

/* ===== Buttons (base) ===== */
.ReusablePopup_popup-actions__P4YXK button {
  flex: 1 1;
  min-height: 40px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.05s ease,
    box-shadow 0.15s ease;
  font-family: inherit;
}

.ReusablePopup_popup-actions__P4YXK button:active {
  transform: translateY(1px);
}

.ReusablePopup_popup-actions__P4YXK button:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* ===== Cancel button ===== */
.ReusablePopup_popup-cancel-btn__T81JZ {
  background: #ffffff;
  color: #374151;
  border: 1px solid #00000024 !important;
}

.ReusablePopup_popup-cancel-btn__T81JZ:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

/* ===== Confirm button ===== */
.ReusablePopup_popup-confirm-btn__n8tcV {
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
  box-shadow: 0 1px 2px rgba(79, 70, 229, 0.25);
}

.ReusablePopup_popup-confirm-btn__n8tcV:hover {
  background: #4338ca;
  border-color: #4338ca;
}

/* ===== Animations ===== */
@keyframes ReusablePopup_popup-fade-in__-bcDJ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ReusablePopup_popup-scale-in__tEZIu {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.ReusablePopup_popup-input__deuAY {
  width: 100%;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.ReusablePopup_popup-input__deuAY:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}
/* ===== Mobile tweaks ===== */
@media (max-width: 480px) {
  .ReusablePopup_popup-container__-g4G5 {
    padding: 22px 18px 16px;
    border-radius: 12px;
  }

  .ReusablePopup_popup-heading__qgXhS {
    font-size: 16px;
  }

  .ReusablePopup_popup-actions__P4YXK {
    flex-direction: column-reverse;
  }

  .ReusablePopup_popup-actions__P4YXK button {
    width: 100%;
  }
}

.ReusablePopup_popup-confirm-btn__n8tcV.ReusablePopup_danger__1rJT1 {
  background: #dc2626;
  border-color: #dc2626;
  box-shadow: 0 1px 2px rgba(220, 38, 38, 0.25);
}
.ReusablePopup_popup-confirm-btn__n8tcV.ReusablePopup_danger__1rJT1:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/ReusablePopup.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAAuC;EACvC,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,mBAAmB;EACnB;;qCAEmC;EACnC,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kFAA6D;EAC7D,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf;;;;yBAIuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,8BAA8B;AAC9B;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* ===== Overlay ===== */\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: popup-fade-in 0.18s ease-out;\n  padding: 16px;\n}\n\n/* ===== Container ===== */\n.popup-container {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow:\n    0 20px 40px rgba(15, 23, 42, 0.18),\n    0 4px 12px rgba(15, 23, 42, 0.08);\n  width: 100%;\n  max-width: 440px;\n  padding: 28px 24px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  animation: popup-scale-in 0.2s cubic-bezier(0.22, 1, 0.36, 1);\n  position: relative;\n}\n\n/* ===== Icon ===== */\n.popup-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(79, 70, 229, 0.1);\n  margin-bottom: 14px;\n  font-size: 24px;\n  line-height: 1;\n}\n\n/* ===== Heading ===== */\n.popup-heading {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n  line-height: 1.35;\n}\n\n/* ===== Subtext ===== */\n.popup-subtext {\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n}\n\n/* ===== Paragraph ===== */\n.popup-paragraph {\n  font-size: 14px;\n  font-weight: 400;\n  color: #4b5563;\n  margin: 0 0 20px 0;\n  line-height: 1.55;\n}\n\n/* ===== Actions ===== */\n.popup-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n/* ===== Buttons (base) ===== */\n.popup-actions button {\n  flex: 1;\n  min-height: 40px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    transform 0.05s ease,\n    box-shadow 0.15s ease;\n  font-family: inherit;\n}\n\n.popup-actions button:active {\n  transform: translateY(1px);\n}\n\n.popup-actions button:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* ===== Cancel button ===== */\n.popup-cancel-btn {\n  background: #ffffff;\n  color: #374151;\n  border: 1px solid #00000024 !important;\n}\n\n.popup-cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n/* ===== Confirm button ===== */\n.popup-confirm-btn {\n  background: #4f46e5;\n  color: #ffffff;\n  border-color: #4f46e5;\n  box-shadow: 0 1px 2px rgba(79, 70, 229, 0.25);\n}\n\n.popup-confirm-btn:hover {\n  background: #4338ca;\n  border-color: #4338ca;\n}\n\n/* ===== Animations ===== */\n@keyframes popup-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes popup-scale-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n.popup-input {\n  width: 100%;\n  margin-top: 12px;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.popup-input:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n}\n/* ===== Mobile tweaks ===== */\n@media (max-width: 480px) {\n  .popup-container {\n    padding: 22px 18px 16px;\n    border-radius: 12px;\n  }\n\n  .popup-heading {\n    font-size: 16px;\n  }\n\n  .popup-actions {\n    flex-direction: column-reverse;\n  }\n\n  .popup-actions button {\n    width: 100%;\n  }\n}\n\n.popup-confirm-btn.danger {\n  background: #dc2626;\n  border-color: #dc2626;\n  box-shadow: 0 1px 2px rgba(220, 38, 38, 0.25);\n}\n.popup-confirm-btn.danger:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup-overlay": `ReusablePopup_popup-overlay__ecyoL`,
	"popup-fade-in": `ReusablePopup_popup-fade-in__-bcDJ`,
	"popup-container": `ReusablePopup_popup-container__-g4G5`,
	"popup-scale-in": `ReusablePopup_popup-scale-in__tEZIu`,
	"popup-icon": `ReusablePopup_popup-icon__luDfL`,
	"popup-heading": `ReusablePopup_popup-heading__qgXhS`,
	"popup-subtext": `ReusablePopup_popup-subtext__IZLeZ`,
	"popup-paragraph": `ReusablePopup_popup-paragraph__INKTF`,
	"popup-actions": `ReusablePopup_popup-actions__P4YXK`,
	"popup-cancel-btn": `ReusablePopup_popup-cancel-btn__T81JZ`,
	"popup-confirm-btn": `ReusablePopup_popup-confirm-btn__n8tcV`,
	"popup-input": `ReusablePopup_popup-input__deuAY`,
	"danger": `ReusablePopup_danger__1rJT1`
};
export default ___CSS_LOADER_EXPORT___;
